import React from 'react';
import { withOptimizely } from 'shared/optimizely';
import { useMobileMapViewButton } from 'shared/hooks/optimizely/useMobileMapViewButton';
import {
    CreateNotificationButton,
    MapViewButton,
    SSRMediaQuery
} from 'shared/components';
import { MobileQuickMenuStyled } from './SearchResultMobileQuickMenu.styles';

export const SearchResultMobileQuickMenu: React.FC = withOptimizely(
    ({ optimizely }) => {
        const isWithinExperimentSr796 = useMobileMapViewButton(optimizely);

        return (
            <SSRMediaQuery
                breakpoint="medium"
                additionalCondition={isWithinExperimentSr796}
            >
                <MobileQuickMenuStyled
                    LeftButton={
                        <CreateNotificationButton
                            trackingEventCategory="search results"
                            trackingEventLabel="create_alert"
                        />
                    }
                    RightButton={<MapViewButton />}
                />
            </SSRMediaQuery>
        );
    }
);
